//変数
const humOpen = document.querySelector('.openbtn');
const body = document.body;
const nav = document.querySelector('.nav');
const navBgLists = document.querySelectorAll('.nav_img_bg__item');
const hero = document.getElementById('hero');
const heroHeight = hero.clientHeight;
const progress = document.querySelector('.progress');
const header = document.querySelector('.header');
const sectionLinks = document.querySelectorAll('.progress_list__link');
const sections = document.querySelectorAll('.section_area');
let set_position = 0;

const goodsTtl = document.querySelector('.goods_info_item__ttl');
const goodsSubTtl = document.querySelector('.goods_info_item__sub_ttl');
const goodsTxt = document.querySelector('.goods_info_item__txt');
const goodsLink = document.querySelector('.goods_info_item__link');

// ローディング時の処理
window.addEventListener('load', (event) => {
  const spinner = document.getElementById('loading');
  spinner.classList.add('loaded');
  const page = document.getElementById('page');
  page.style.display = 'block';
});
// スマホでヒーローを全画面にする
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setHeight();

//window.addEventListener('resize', setHeight);

//ハンバーガーメニュー

function navFunc() {
  body.classList.toggle('active');
  nav.classList.toggle('active');
  humOpen.classList.toggle('active');
}
humOpen.addEventListener('click', navFunc);

//ナビゲーション

//ナビゲーションメニューの背景を入れ替える処理（PCのみ適用）
if (!window.matchMedia('(max-width: 991px)').matches) {
  menuFunc();
}

function menuFunc() {
  //初期化
  document.querySelector('.nav_img_bg__item--1').classList.add('active');

  nav.addEventListener('mousemove', function (e) {
    const clicked = e.target.closest('.nav_main_list__link');

    if (!clicked) return;

    navBgLists.forEach((c) => c.classList.remove('active'));

    document
      .querySelector(`.nav_img_bg__item--${clicked.dataset.nav}`)
      .classList.add('active');
  });
}
//メニューリンクをクリックしたらナビゲーションを閉じる処理
nav.addEventListener('click', function (e) {
  if (e.target.classList.contains('nav_main_list__link')) {
    setTimeout(navFunc, 100);
  }
});

// ヘッダーのスクロール制御

window.addEventListener('scroll', function () {
  if (!nav.classList.contains('active')) {
    if (set_position < document.documentElement.scrollTop) {
      //   console.log(`down`);
      header.classList.add('active');
    } else {
      // console.log(`up`);
      header.classList.remove('active');
    }
  }
  set_position = document.documentElement.scrollTop;
});

//elevatorリンク
function elevatorFunc() {
  window.addEventListener('scroll', function () {
    if (
      document.body.scrollTop > heroHeight ||
      document.documentElement.scrollTop > heroHeight
    ) {
      progress.classList.add('active');
    } else {
      progress.classList.remove('active');
    }

    sectionLinks.forEach((link, index) => {
      //document要素の絶対位置(値は固定) window.pageYOffsetはdocumentの上端からのスクロール量
      const absolutePositionTop =
        sections[index].getBoundingClientRect().top + window.pageYOffset;
      if (document.documentElement.scrollTop > absolutePositionTop) {
        link.classList.add('inview');
      } else {
        link.classList.remove('inview');
      }
    });
  });
}

//goodsの内容書き換え

const goodsArray = {
  ttl: ['HERVE', 'a.market', 'Fashion'],
  sub: ['エルブ', 'aマーケット', 'ファッション'],
  txt: [
    'まるでジュエリーのようなインセンスホルダー。泳ぐ真鍮の線が、上品ながらも遊び心くすぐられるデザインに仕上がっております。自由な線で香りを描く。アクセサリーを身に着ける感覚で空間に飾ってください。',
    'どこか懐かしさ漂う、レトロで洗練されたグラスたち。海外の蚤の市でみつけた時の『特別感』を、a.depeche marketからお届けします。キラキラした光を取り込み、植物をより一層素敵に魅せてくれます。',
    'いつものアイテムに「signal」をプラスして自分だけのカラーを彩るコレクション。そういったベーシックなアイテムにsignal colorのカーディガンやベストをレイヤードしていって今の気分とマッチしたお気に入りの装いに ...',
  ],
  link: [
    'https://www.a-depeche.jp/c/new/2022aw/020-her-ich',
    'https://www.a-depeche.jp/c/series/amarket-series',
    'https://www.a-depeche.jp/s/page/2022aw/2022aw-apparel.html',
  ],
};

import { ScrollObserver } from './scroll';

//インターセクションオブザーバー

//PC用処理

class MainPC {
  constructor() {
    this._observers = [];
    this._scrollInit();
  }

  _scrollInit() {
    this._observers.push(
      new ScrollObserver('.appear', this._inviewAnimation.bind(this), {
        once: true,
        rootMargin: '0px 0px -500px 0px',
      }),
      new ScrollObserver('.apperarTxtAnime', this._inviewAnimation.bind(this), {
        once: false,
        rootMargin: '0px 0px 10px 0px',
      }),
      new ScrollObserver('.goods_info_img--1', this._goodsText1.bind(this), {
        once: false,
        rootMargin: '0px 0px -500px 0px',
      }),
      new ScrollObserver('.goods_info_img--2', this._goodsText2.bind(this), {
        once: false,
        rootMargin: '0px 0px -500px 0px',
      }),
      new ScrollObserver('.goods_info_img--3', this._goodsText3.bind(this), {
        once: false,
        rootMargin: '0px 0px -500px 0px',
      })
    );
  }

  _inviewAnimation(el, inview) {
    if (inview) {
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }

  _goodsText1(el, inview) {
    if (inview) {
      goodsTtl.textContent = goodsArray['ttl'][0];
      goodsSubTtl.textContent = goodsArray['sub'][0];
      goodsTxt.textContent = goodsArray['txt'][0];
      goodsLink.setAttribute('href', goodsArray['link'][0]);
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }
  _goodsText2(el, inview) {
    if (inview) {
      goodsTtl.textContent = goodsArray['ttl'][1];
      goodsSubTtl.textContent = goodsArray['sub'][1];
      goodsTxt.textContent = goodsArray['txt'][1];
      goodsLink.setAttribute('href', goodsArray['link'][1]);
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }
  _goodsText3(el, inview) {
    if (inview) {
      goodsTtl.textContent = goodsArray['ttl'][2];
      goodsSubTtl.textContent = goodsArray['sub'][2];
      goodsTxt.textContent = goodsArray['txt'][2];
      goodsLink.setAttribute('href', goodsArray['link'][2]);
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }
}
//スマホ用処理
class MainSP {
  constructor() {
    this._observers = [];
    this._scrollInit();
  }

  _scrollInit() {
    this._observers.push(
      new ScrollObserver('.appear', this._inviewAnimation.bind(this), {
        once: true,
        rootMargin: '0px 0px -300px 0px',
      }),
      new ScrollObserver('.apperarTxtAnime', this._inviewAnimation.bind(this), {
        once: false,
        rootMargin: '0px 0px 10px 0px',
      })
    );
  }

  _inviewAnimation(el, inview) {
    if (inview) {
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }
}

if (window.matchMedia('(max-width: 991px)').matches) {
  //PC
  //オブザーバーAPI
  const main = new MainSP();
} else {
  //sp
  //オブザーバーAPI
  const main = new MainPC();
  elevatorFunc();
}
